import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { LOGIN_FAIL } from '@comeon/actions-public';

import { accountUpdate } from '~/components/account/ducks';
import { tracking, updateSessionCriteria } from '~/components/authentication/playnow/steps/DGA/ducks';
import { LOGIN_FAILS_CODES, VERIFICATION_STEP } from '~/components/authentication/playnow/steps/DGA/constants';
import { enableValidateSession, updateCredentials, validateSession } from '~/components/authentication/ducks';
import { showNotification } from '~/components/notifications/ducks/notifications';
import useWizard from '~/components/authentication/wizard/hooks/use-wizard';

const useResponse = () => {
	const dispatch = useDispatch();

	const [updated, setUpdate] = useState(false);

	const { next } = useWizard();

	const handleErrors = useCallback(
		({ error, provider, playerId = null }) => {
			if (LOGIN_FAILS_CODES.indexOf(error) !== -1) {
				dispatch({
					type: LOGIN_FAIL,
					payload: { errorCode: error, withinSidebar: true, result: { playerId } }
				});
			} else {
				dispatch(
					showNotification({
						messageKey: error,
						color: 'red',
						autoHide: true,
						openInSidebar: true
					})
				);
			}

			dispatch(tracking({ error, provider }));
		},
		[dispatch]
	);

	const handleSuccess = useCallback(
		async response => {
			const {
				showWelcomePageDetails = false,
				depositLimitCountryCode,
				isRegistration,
				...sessionCriteria
			} = response?.verificationMap ?? {};

			dispatch(
				updateSessionCriteria({
					...sessionCriteria,
					depositLimitCountryCode,
					showWelcomePageDetails,
					isRegistration,
					showRegistrationFlow:
						isRegistration || sessionCriteria.showDepositLimits || sessionCriteria.showRegistrationForm
				})
			);
			dispatch(
				accountUpdate({
					...(response?.encryptedPlayerId ? { id: response.encryptedPlayerId } : {}),
					hasAutofilledAddress: response?.hasAutofilledAddress ?? false,
					isRegistration
				})
			);
			dispatch(
				updateCredentials({
					...(response?.userData ?? {})
				})
			);

			if (Object.keys(sessionCriteria).every(k => !sessionCriteria[k])) {
				dispatch(enableValidateSession());
				await dispatch(validateSession({ skipAnalytics: true }, true));
				dispatch(tracking({ provider: VERIFICATION_STEP.MITID }));
			} else {
				dispatch(tracking({ trackRegistration: true, provider: VERIFICATION_STEP.MITID }));
			}

			setUpdate(true);
			dispatch(
				showNotification({
					messageKey: 'MITID_VERIFICATION_SUCCESS',
					color: 'green',
					autoHide: true
				})
			);
		},
		[dispatch]
	);

	useEffect(() => {
		if (updated) {
			next();
		}
	}, [next, updated]);

	return { handleErrors, handleSuccess };
};

export default useResponse;
